import { INVENTORY, PLACEMENT_TYPE_HERO } from "../helpers/consts";
import ElevatedTile from "../components/object-graphics/TileElevated";
import { TILES } from "../helpers/tiles";
import { PickupPlacement } from "./PickupPlacement";

export class FlourPickupPlacement extends PickupPlacement {
  addsItemToInventoryOnCollide(body) {
    if (body.type === PLACEMENT_TYPE_HERO) {
      return INVENTORY.FLOUR_PICKUP;
    }
    return null;
  }

  renderComponent() {
    return <ElevatedTile frameCoord={TILES.FLOUR} hover={true} />;
  }
}
